<template lang="pug">
.character-messages
  .message-container
    .image-container(v-if="characterImage")
      img(:src="require('../assets/images/characters/' + characterImage)")
    .text-container
      .title(v-if="messageTitle")
        FontShadow(:textContent="messageTitle", shadowColor="rgba(196, 196, 196, 0.2)", mobileTextAlign="center", mobileShadowAlign="left")
      .description(v-if="messageContent")
        p(v-html="messageContent")
</template>

<script>
import FontShadow from '../components/font-shadow.vue'

export default {
  props: ['characterImage', 'messageTitle', 'messageContent'],
  components: {
    FontShadow
  }
}
</script>

<style lang="sass">
@import '../sass/_variables.sass'

.character-messages
  display: flex
  background-color: white
  width: 100%
  .message-container
    display: flex
    align-items: center
    justify-content: center
    margin: 0 auto
    padding-top: 40px
    padding-bottom: 50px
    +mobile
      flex-direction: column
      padding-left: 0
      padding-top: 30px
    .image-container
      flex: 0
      img
        width: 250px
        +mobile
          width: 300px
    .text-container
      flex: 1
      margin-left: 50px
      +mobile
        margin-left: 0
      p
        text-align: left
        +mobile
          text-align: center
          padding: 0 10px
</style>
